import RegionWarning from "../../../../contents/docs/advanced/_snippets/region-warning.mdx";
import diagram from "../../../../contents/images/docs/cloud/cloudfront-proxy/cache-policy.png";
import * as React from 'react';
export default {
  RegionWarning,
  diagram,
  React
};